import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import DataSourceInstance from '@/model/DataSourceInstance';


export default class GeneratedDataSourceInstanceStore {

    state: {
        dataSourceInstances: Map<number, DataSourceInstance>,
        calls: Map<string, number | number[]>
    }
    timer: number | null = null

    constructor() {
        let dataSourceInstances: Map<number, DataSourceInstance> | null = null
        try {
            const persistedState = localStorage.getItem('DataSourceInstanceStore')
            if (persistedState) {
                dataSourceInstances = new Map(JSON.parse(persistedState))
            }
        } catch (ignore) {}
        this.state = reactive({
            dataSourceInstances: dataSourceInstances || new Map<number, DataSourceInstance>(),
            calls: new Map<string, number | number[]>()
        })
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    persistState() {
        if (this.timer === null) {
            setTimeout(() => {
                localStorage.setItem('DataSourceInstanceStore', JSON.stringify(Array.from(this.state.dataSourceInstances)))
                this.timer = null
            }, 1000)
        }
    }

    clearState() {
        if (this.timer) clearTimeout(this.timer)
        if (this.state?.dataSourceInstances) this.state.dataSourceInstances.clear()
        if (this.state?.calls) this.state.calls.clear()
        localStorage.removeItem('DataSourceInstanceStore')
    }

    addOrReplaceDataSourceInstance(newDataSourceInstance: DataSourceInstance, persist: boolean = true): true | undefined {
        if (newDataSourceInstance.id) {
            this.state.dataSourceInstances.set(newDataSourceInstance.id, newDataSourceInstance)
            
            if (persist) {
                this.persistState()
            } else {
                return true
            }
        }
    }
    
    addOrReplaceDataSourceInstances(newDataSourceInstances: DataSourceInstance[]) {
        let persist = false
        for (const newDataSourceInstance of newDataSourceInstances) {
            const changed = !!this.addOrReplaceDataSourceInstance(newDataSourceInstance, false)
            persist = persist || changed
        }
        if (persist) {
            this.persistState()
        }
    }

    replaceDataSourceInstances(dataSourceInstances: DataSourceInstance[]) {
        const newDataSourceInstances = new Map<number, DataSourceInstance>()
        for (const newDataSourceInstance of dataSourceInstances) {
            if (newDataSourceInstance.id) {
                newDataSourceInstances.set(newDataSourceInstance.id, newDataSourceInstance)
                
            }
        }
        this.state.dataSourceInstances = newDataSourceInstances
        this.persistState()
    }

    removeDataSourceInstance(id: number | undefined | null, persist: boolean = true): true | undefined {
        if (id !== undefined && id !== null) {
            if (this.state.dataSourceInstances.delete(id)) {
                if (persist) {
                    this.persistState()
                } else {
                    return true
                }
            }
        }
    }

    removeDataSourceInstances(ids: (number | null)[] | undefined | null) {
        let persist = false
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                const changed = !!this.removeDataSourceInstance(id, false)
                persist = persist || changed
            }
        }
        if (persist) {
            this.persistState()
        }
    }
}